var _circle, _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInviteSpouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 140,
    viewBox: "0 0 139 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5,
    cy: 34.5,
    r: 28.5,
    fill: "#284993"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114 129.688C114 131.897 112.209 133.688 110 133.688H28C25.7909 133.688 24 131.897 24 129.688V114.688C24 89.8347 44.1472 69.6875 69 69.6875V69.6875C93.8528 69.6875 114 89.8347 114 114.688V129.688Z",
    fill: "#284993"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    transform: "matrix(1 0 0 -1 89 114)",
    fill: "#306153"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.874 104.953L104.436 104.953C106.887 104.953 108.874 102.966 108.874 100.515L108.874 90.4528C108.874 89.0721 107.755 87.9528 106.374 87.9528V87.9528C104.993 87.9528 103.874 89.0721 103.874 90.4528L103.874 104.953Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.374 93.9528C113.755 93.9528 114.874 95.0721 114.874 96.4528V96.4528C114.874 97.8335 113.755 98.9528 112.374 98.9528L100.374 98.9528C98.9934 98.9528 97.8741 97.8335 97.8741 96.4528V96.4528C97.8741 95.0721 98.9934 93.9528 100.374 93.9528L112.374 93.9528Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInviteSpouse);
export default __webpack_public_path__ + "static/media/Icon-Invite_Spouse.b884e01f45b69393fe8390eb53431f6c.svg";
export { ForwardRef as ReactComponent };